export default {"src":"/_next/static/media/blobman3.38485035.svg","height":151,"width":181,"blurWidth":0,"blurHeight":0};